module.exports = __webpack_public_path__ + "static/media/Status_Closed.9f480e6a.svg";